var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getShowModal())?_c('article',{staticClass:"modal"},[_c('section',{staticClass:"modal__container"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }